// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"8096":"vendors","8792":"main"}[chunkId] + "." + {"8096":"9ef8d770","8792":"80c18f2e"}[chunkId] + ".css";
};